/*
 * Ryan O'Dowd
 * 2023-01-21
 * © Copyright 2023 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({isDarkMode, fonts, colors}) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      padding: 8,
      borderRadius: 8,
      margin: 4,
      borderStyle: 'solid',
      borderWidth: 2,
      borderColor: colors.primary,
    },
    generalFeedbackContainer: {
      borderColor: colors.incorrectText,
    },
    upvotedContainer: {
      borderColor: colors.accentDark,
    },
    downvotedContainer: {
      borderColor: colors.incorrect,
    },
    aboveFold: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    translations: {
      flex: 1,
      flexDirection: 'column',
      cursor: 'pointer',
    },
    generalFeedbackTitle: {
      fontWeight: '600',
      fontSize: 20,
    },
    newNoteWrapper: {
      flex: 1,
      flexDirection: 'row',
      marginTop: 16,
      paddingTop: 8,
      borderTopStyle: 'solid',
      borderTopWidth: 1,
      borderTopColor: colors.lightGray,
    },
    saveButtonWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
    },
    buttons: {
      display: 'flex',
      flexDirection: 'row',
    },
    translationRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    locale: {
      fontWeight: '600',
      color: isDarkMode ? colors.primaryExtraLight : colors.primaryExtraDark,
      marginRight: 8,
    },
    highlightedText: {
      backgroundColor: colors.accent,
    },

    notesWrapper: {
      display: 'flex',
      flexDirection: 'column',
      borderTopStyle: 'solid',
      borderTopWidth: 1,
      borderTopColor: colors.primary,
      marginTop: 4,
      padding: 8,
    },
    updateDialogContent: {
      width: 400,
    },
    searchBar: { // @TODO: should this be its own component?
      display: 'flex',
      // @TODO: height: 40, // @TODO: maybe this is good for help component only
      fontFamily: fonts.primary,
    },
  };
};

export default getStyles;
